import React from 'react';
import { credits, HOUSE_FEE_PCT } from './nxlUtils';

function NxlDashboardHeader({
  stats,
  markets,
  dashboard,
  lastUpdated,
  refreshAll,
  loading,
}) {
  return (
    <>
      <section className="nxl-hero">
        <p className="nxl-kicker">NXL PREDICTION MARKET</p>
        <h1>Live scheduled-match market dashboard.</h1>
        <p>
          Trade simulated credits on scheduled PBLeagues matchups. Model odds estimate team strength;
          final payouts come from the matchup pool.
        </p>

        <div className="nxl-live-row">
          <span className="nxl-live-pill">Live Dashboard</span>
          <span>{lastUpdated ? `Updated ${lastUpdated.toLocaleTimeString()}` : 'Waiting for data'}</span>
          <button onClick={refreshAll} disabled={loading}>
            {loading ? 'Refreshing…' : 'Refresh'}
          </button>
        </div>
      </section>

      <section className="nxl-stat-grid">
        <div className="nxl-stat-card">
          <span>Scheduled Markets</span>
          <strong>{stats?.markets ?? markets.length ?? '—'}</strong>
        </div>

        <div className="nxl-stat-card">
          <span>Open</span>
          <strong>{stats?.openMarkets ?? markets.length ?? '—'}</strong>
        </div>

        <div className="nxl-stat-card">
          <span>House Fee</span>
          <strong>{HOUSE_FEE_PCT}%</strong>
        </div>

        <div className="nxl-stat-card">
          <span>Your Balance</span>
          <strong>{dashboard?.wallet?.balance !== undefined ? credits(dashboard.wallet.balance) : '—'}</strong>
          <em>{dashboard?.positions?.open || 0} open positions</em>
        </div>
      </section>
    </>
  );
}

export default NxlDashboardHeader;